module.exports = __webpack_public_path__ + "img/imageStamp.0dd74105.png";